module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "http://echarts.baidu.com/api.html#echarts"
    }
  }, [_vm._v("参考api：http://echarts.baidu.com/api.html#echarts")]), _vm._v(" "), _c('div', {
    staticClass: "echart",
    attrs: {
      "id": "echarts1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart",
    attrs: {
      "id": "echarts2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart",
    attrs: {
      "id": "Dashboard"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart",
    attrs: {
      "id": "echarts3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart",
    attrs: {
      "id": "echarts4"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f38fb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Echarts.vue
// module id = 602
// module chunks = 2